import React from "react";
import { Link } from 'react-router-dom';

const BottomPanel = (props) => {
    return  (
	 	<div className="bottom-panel">
	        <div className="social-btn">
	            <a className="social-btn__item" href="https://www.vk.com/garpixofficial">
					<img src="/static/images/vk.svg" alt=""/>
				</a>
	            <a className="social-btn__item" href="https://www.facebook.com/garpixofficial">
					<img src="/static/images/facebook.svg" alt=""/>
				</a>
	        </div>
	        <div className="container">
	            <div className="left-content-width">
	                <div className="terms-of-use">
						<Link to="/information/terms-use">Правила <span className="text_pink">использования</span></Link>
	                </div>
	            </div>
	        </div>
	        <div className="space">
	        </div>
	    </div>
    )
}

export default BottomPanel


// WEBPACK FOOTER //
// ./src/components/BottomPanel.js